import { useState, useRef, useEffect } from "react";
import { Flex } from "../division";
import { SelectWrapper } from "../selectwrapper/SelectWrapper";
import { DivWrapper } from "./styles";
import { withTranslation } from "react-i18next";

function Select({
  options, icon, required, placeholder, editable, testId, background,
  translate, defaultValue, reset, resetValue, validate, handleChange: handleChangeProp, name, t
}) {
  const selectInput = useRef(null);
  const mouseOverOptions = useRef(false);
  const tempString = useRef("");
  const isFirstRender = useRef(true);

  const [showoptions, setShowoptions] = useState(false);
  const [currentValue, setCurrentValue] = useState(defaultValue || "");

  // Only reset when the `reset` prop *changes* to truthy (not on initial mount)
  // never fired on initial mount.
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (reset) {
      setCurrentValue(resetValue || "");
      if (selectInput.current) selectInput.current.value = resetValue || "";
    }
  }, [reset, resetValue]);

  const hideOptions = () => {
    setShowoptions(false);
    mouseOverOptions.current = false;
  };

  const decideDisplay = () => {
    if (!mouseOverOptions.current) hideOptions();
  };

  const selectOption = (option) => {
    setCurrentValue(option);
    if (selectInput.current) selectInput.current.value = option;
    handleChangeProp(name, option);
    hideOptions();
  };

  const handleBlur = (e) => {
    if (validate && tempString.current) {
      if (validate(tempString.current)) {
        setCurrentValue(tempString.current);
        handleChangeProp(name, tempString.current);
        tempString.current = "";
      } else {
        tempString.current = "";
        e.target.value = currentValue;
      }
    }
    decideDisplay();
  };

  const handleInputChange = (e) => {
    tempString.current = e.target.value;
    handleChangeProp(name, e.target.value);
  };

  return (
    <SelectWrapper
      data-testid="select-component"
      aria-expanded={showoptions}
      background={background}
    >
      <Flex>
        <input
          data-testid="select-input"
          data-time-test-id={testId}
          readOnly={!editable}
          onClick={() => setShowoptions(true)}
          onBlur={handleBlur}
          defaultValue={currentValue}
          placeholder={placeholder}
          required={required}
          onChange={handleInputChange}
          ref={selectInput}
        />
        <img src={icon} alt="select" loading="lazy" />
        {options && (
          <DivWrapper
            data-testid="options"
            show={showoptions}
            onMouseLeave={hideOptions}
            onMouseEnter={() => { mouseOverOptions.current = true; }}
          >
            {(Array.isArray(options) ? options : [options]).map((option, i) => (
              <div data-testid="option" key={i} onClick={() => selectOption(option)}>
                {translate && translate(option) ? t(option) : option}
              </div>
            ))}
          </DivWrapper>
        )}
      </Flex>
    </SelectWrapper>
  );
}

export default withTranslation()(Select);